export const buildInitialValues = (inContextTheme, flattenedStore = {}) => {
    var values = {};

    for (var i = 0; i < inContextTheme.length; i++) {
        var item = inContextTheme[i];

        // Colors
        if (item.key === 'colors' && item.groups) {
            for (var g = 0; g < item.groups.length; g++) {
                var group = item.groups[g];
                for (var r = 0; r < group.rows.length; r++) {
                    var row = group.rows[r];
                    // Use store value if available, otherwise use default
                    values[row.key] = flattenedStore[row.key] || row.defaultValue || '#FFFFFF';
                }
            }
        }

        // Typography
        if (item.key === 'typography' && item.groups) {
            for (var tg = 0; tg < item.groups.length; tg++) {
                var tgroup = item.groups[tg];
                for (var tr = 0; tr < tgroup.rows.length; tr++) {
                    var trow = tgroup.rows[tr];
                    values[trow.key] = flattenedStore[trow.key] || trow.defaultValue || '';
                }
            }
        }

        // Spacing or Radius
        if (item.key === 'spacing' || item.key === 'radius') {
            // Parse rem values from store back to numeric values for sliders
            const storeValue = flattenedStore[item.key];
            let parsedValue = item.defaultValue || 0;
            
            if (storeValue && typeof storeValue === 'string' && storeValue.includes('rem')) {
                parsedValue = parseFloat(storeValue.replace('rem', ''));
            } else if (storeValue !== undefined && storeValue !== null && storeValue !== '') {
                parsedValue = parseFloat(storeValue) || parsedValue;
            }
            
            values[item.key] = parsedValue;
        }
        
        // Shadow
        if (item.key === 'shadow' && item.groups) {
            for (var sg = 0; sg < item.groups.length; sg++) {
                var shadowGroup = item.groups[sg];
                const storeValue = flattenedStore[shadowGroup.key];
                let parsedValue = shadowGroup.defaultValue || '0';
                
                // Parse px values from store back to numeric values for sliders (except for color and opacity)
                if (shadowGroup.key === 'shadow-color') {
                    // Color should remain as-is
                    parsedValue = storeValue || parsedValue;
                } else if (shadowGroup.key === 'shadow-opacity') {
                    // Opacity should remain as numeric
                    parsedValue = storeValue !== undefined && storeValue !== null && storeValue !== '' 
                        ? parseFloat(storeValue) || parsedValue 
                        : parsedValue;
                } else if (storeValue && typeof storeValue === 'string' && storeValue.includes('px')) {
                    // Other shadow properties with px units
                    parsedValue = parseFloat(storeValue.replace('px', ''));
                } else if (storeValue !== undefined && storeValue !== null && storeValue !== '') {
                    parsedValue = parseFloat(storeValue) || parsedValue;
                }
                
                values[shadowGroup.key] = parsedValue;
            }
        }
    }

    return values;
};


// WEBPACK FOOTER //
// ./src/components/pages/in-context/SidebarNavigation/utils/themeUtils.js